import {
  api_CancelSalesOrderByCustomer,
  api_LoadMobileSalesOrder,
} from "../../../../connection/api/api-orders";
import {
  PT_VIEWINVOICE,
  PT_ORDERS,
} from "../../../../routes/stack/paths/pt-orders";
import { CSP, ENCRYPT_STORAGE } from "../../../../config/config";
import { GET_SET_STORED_DATA } from "../../../../database/get-stored-data";
import { SET_STORE_PAGE_URL } from "../../../../database/store-data";
import { CONCAT_TEXT_LIMIT } from "../../../../functions/funtion";
import { F_Fammily, Font } from "../../../../util/config-fonts";
import { PT_SIGNIN } from "../../../../routes/stack/paths/pt-profile";
import { Colors } from "../../../../util/colors";
import { ENTRY_MODE } from "../../../../database/store-names";
import COMPLETEDORDERS from "../../../profile/pg-profile-completed-orders";
import CancelledOrders from "../../pg-cancelled-orders";
import Alert from "../../../../components/Alert";
import React from "react";
import d1 from "./d1.png";
import d2 from "./d2.png";
import d3 from "./d3.png";
import p1 from "./p1.png";
import p2 from "./p2.png";
import "../../../../styles/css/pg-order-header.css";

export default class ORDERVIEW extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      SalesInvoicePendingPOSInvoice: [],
      intervalId: 0,
      activeTab: "running",
    };
  }

  handleChange(activeTab) {
    if (this._isMounted) {
      this.setState({ activeTab });
    }
  }

  async LoadPendingInvoiceFirst() {
    if (this.state.activeTab !== "running") {
      return;
    }
    let data = await api_LoadMobileSalesOrder();
    let objData = JSON.parse(data);
    if (objData === "[]") {
      this.setState({ SalesInvoicePendingPOSInvoice: [] });
    } else {
      this.setState({ SalesInvoicePendingPOSInvoice: [] });
      let objobjData = JSON.parse(objData);
      this.setState({ SalesInvoicePendingPOSInvoice: objobjData });
    }
  }

async componentDidMount() {
  this._isMounted = true;
  await GET_SET_STORED_DATA();

  if (this.props.CSID !== 0) {
    if (!this.state.checked) {
      await this.LoadPendingInvoiceFirst();

      this.intervalId = setInterval(async () => {
        // Check if component is still mounted before doing anything
        if (this._isMounted && !this.state.checked) {
          await this.LoadPendingInvoiceFirst();
        }
      }, 8000);
    }
  }
}

componentWillUnmount() {
  this._isMounted = false;
  // Clear the interval using the class property we stored it in
  if (this.intervalId) {
    clearInterval(this.intervalId);
  }
}

  displayOrderProcess(
    IsOnHold,
    IsPicked,
    Delivered,
    IsRiderAccepted,
    DineType
  ) {
    if (IsOnHold === true && DineType === 4) {
      return (
        <img
          src={d1}
          alt="imageD1"
          className="pgOrderProcessImg"
          style={{ top: "50px" }}
        />
      );
    } else if (IsOnHold === false && DineType === 4 && IsPicked === false) {
      return (
        <img
          src={d2}
          alt="imageD1"
          className="pgOrderProcessImg"
          style={{ top: "50px" }}
        />
      );
    } else if (IsOnHold === false && DineType === 4 && IsPicked === true) {
      return (
        <img
          src={d3}
          alt="imageD1"
          className="pgOrderProcessImg"
          style={{ top: "50px" }}
        />
      );
    } else if (IsOnHold === true && DineType === 3) {
      return (
        <img
          src={p1}
          alt="imageD1"
          className="pgOrderProcessImg"
          style={{ top: "50px" }}
        />
      );
    } else if (IsOnHold === false && DineType === 3) {
      return (
        <img
          src={p2}
          alt="imageD1"
          className="pgOrderProcessImg"
          style={{ top: "50px" }}
        />
      );
    } else if (IsOnHold === true && IsPicked === true) {
      return (
        <img
          src={d3}
          alt="imageD1"
          className="pgOrderProcessImg"
          style={{ top: "50px" }}
        />
      );
    } else {
      return (
        <img
          src={d2}
          alt="imageD1"
          className="pgOrderProcessImg"
          style={{ top: "50px" }}
        />
      );
    }
  }

  formattedDateTime(DateParamaeter) {
    const date = new Date(DateParamaeter);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is zero-based
    const day = String(date.getDate()).padStart(2, "0");
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12 || 12;

    return `${year}-${month}-${day}\u00A0\u00A0\u00A0 ${hours}:${minutes} ${ampm}`;
  }

  render() {
    let CSID = this.props.CSID;
    const from = ENCRYPT_STORAGE.getItem(ENTRY_MODE);
    const hideCompletedTab = from === "QR";
    return (
      <div
        className="pgOrderLayout fadeInUp animated"
        style={{
          backgroundColor:
            CSP === "MK" || CSP === "DT" ? "rgba(232, 232, 233, 0.5)" : "",
          height: "100vh",
        }}
      >
        {CSID !== 0 ? (
          <>
            <div
              className="orderHeader"
              style={{
                position: "sticky",
                top: 0,
                display: "flex",
                flexDirection: "row",
                width: "100%",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                zIndex: 1000,
              }}
            >
              <div
                className={`switchButton ${
                  this.state.activeTab === "running" ? "active" : ""
                }`}
                onClick={() => this.handleChange("running")}
                style={{ width: "100%" }}
              >
                {"RUNNING"}
              </div>

              <div
                className={`switchButton ${
                  this.state.activeTab === "completed" ? "active" : ""
                }`}
                onClick={() => this.handleChange("completed")}
                style={{
                  display: hideCompletedTab ? "none" : "flex",
                  width: "100%",
                }}
              >
                COMPLETED
              </div>

              <div
                className={`switchButton ${
                  this.state.activeTab === "cancelled" ? "active" : ""
                }`}
                onClick={() => this.handleChange("cancelled")}
                style={{
                  display: "flex",
                  width: "100%",
                }}
              >
                CANCELLED
              </div>
            </div>

            {this.state.activeTab === "running" && (
              <div style={{ paddingBottom: "50px" }}>
                {this.state.SalesInvoicePendingPOSInvoice.length === 0 ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      paddingTop: "60px",
                    }}
                  >
                    <img
                      src={require("../orders-view/NoDataFound.jpg")}
                      width={"60%"}
                      alt=""
                    />

                    <label
                      style={{
                        fontWeight: "bold",
                        marginBottom: "8px",
                        textAlign: "center",
                      }}
                    >
                      No Orders Found
                    </label>
                    <label
                      style={{
                        textAlign: "center",
                        display: "block",
                      }}
                    >
                      Try ordering something
                    </label>
                  </div>
                ) : (
                  ""
                )}

                {this.state.SalesInvoicePendingPOSInvoice.map((rs, i) => (
                  <div
                    className="pgOrderCard fadeInUp animated"
                    key={i + "Invoice"}
                    style={{
                      boxShadow:
                        CSP === "MK" || CSP === "DT"
                          ? "0px 4px 10px rgba(0, 0, 0, 0.3)"
                          : "",
                      borderRadius: CSP === "MK" || CSP === "DT" ? "8px" : "",
                      border:
                        CSP === "MK" || CSP === "DT" ? " 1px solid #ccc" : "",
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        left: 5,
                        top: 5,
                        paddingTop: 3,
                        paddingBottom: 3,
                        paddingLeft: 5,
                        paddingRight: 15,
                        fontSize: Font.SmallDescription,
                        color: "black",
                      }}
                    >
                      <p
                        style={{
                          color: "black",
                          padding: 0,
                          fontSize: Font.Description,
                          margin: 10,
                        }}
                      >
                        #{rs.GUNO}
                      </p>
                    </div>
                    <div
                      style={{
                        position: "absolute",
                        right: 5,
                        top: 5,
                        paddingTop: 3,
                        paddingBottom: 3,
                        paddingLeft: 5,
                        paddingRight: 15,
                        fontSize: Font.SmallDescription,
                        color: "black",
                      }}
                    >
                      <p
                        style={{
                          color: "black",
                          padding: 0,
                          fontFamily: F_Fammily.Medium,
                          margin: 10,
                        }}
                      >
                        {rs.DineType === 4 ? "Delivery" : "Pickup"}
                      </p>
                    </div>
                    <div
                      style={{
                        position: "absolute",
                        right: "27%",
                        top: 30,
                        paddingTop: 5,
                        paddingBottom: 3,
                        paddingLeft: 5,
                        paddingRight: 15,
                        fontSize: Font.Heading,
                        color: "black",
                      }}
                    >
                      {rs.DeliveryDateTime}
                    </div>
                    <div>
                      {this.displayOrderProcess(
                        rs.IsOnHold,
                        rs.IsPicked,
                        rs.Delivered,
                        rs.IsRiderAccepted,
                        rs.DineType
                      )}
                    </div>
                    <div className="pgOrderBtnGroup">
                      <button
                        style={{
                          fontFamily: F_Fammily.Medium,
                          backgroundColor: Colors.DarkGreyScale,
                        }}
                        className="pgOrderInvBtn"
                        onClick={() =>
                          this.props.navigate(
                            PT_VIEWINVOICE.replace(":frmPage", "order").replace(
                              ":orderID",
                              rs.POSID
                            )
                          )
                        }
                      >
                        View Order
                      </button>
                      {rs.WID !== 0 && rs.Delivered === false ? (
                        <>
                          {rs.IsPicked === false ? (
                            <button
                              style={{
                                fontFamily: F_Fammily.Medium,
                                fontSize: 12,
                                textAlign: "center",
                                backgroundColor: "yellow",
                              }}
                              className="pgOrderRideBtn"
                              onClick={() => {
                                window.location.href = "tel:" + rs.RiderPhoneNo;
                              }}
                            >
                              <i className="bi bi-telephone"></i>{" "}
                              {CONCAT_TEXT_LIMIT({
                                length: 13,
                                string: rs.RiderName,
                              })}{" "}
                            </button>
                          ) : (
                            <button
                              style={{
                                fontFamily: F_Fammily.Medium,
                                fontSize: 12,
                                textAlign: "center",
                                backgroundColor: "yellow",
                              }}
                              className="pgOrderRideBtn"
                              onClick={() => {
                                window.location.href = "tel:" + rs.RiderPhoneNo;
                              }}
                            >
                              <i className="bi bi-telephone"></i>{" "}
                              {CONCAT_TEXT_LIMIT({
                                length: 13,
                                string: rs.RiderName,
                              })}{" "}
                            </button>
                          )}
                        </>
                      ) : (
                        <></>
                      )}

                      {rs.IsOnHold === true ? (
                        <button
                          style={{
                            fontFamily: F_Fammily.Medium,
                            border: "1px solid Colors.DarkGreyScale",
                            fontWeight: "bold",
                          }}
                          className="pgOrderCnslBtn"
                          onClick={() => {
                            this.canceleInvoice(rs.POSID);
                          }}
                        >
                          Cancel
                        </button>
                      ) : null}
                    </div>

                    {rs.ContactNo !== "0" &&
                    rs.ContactNo !== "" &&
                    rs.ContactNo !== undefined ? (
                      <button
                        style={{
                          fontFamily: F_Fammily.Medium,
                          backgroundColor: Colors.DarkGreyScale,
                          textDecoration: "none",
                        }}
                        className="pgOrderCallBtn"
                      >
                        <a
                          href={"tel:" + rs.ContactNo}
                          style={{
                            textDecoration: "none",
                            color: "white",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <i className="bi bi-telephone"></i>
                          <span style={{ paddingLeft: "10px" }}>
                            {rs.Merchant}
                          </span>
                        </a>
                      </button>
                    ) : (
                      <button
                        disabled
                        style={{
                          fontFamily: F_Fammily.Medium,
                          backgroundColor: Colors.DarkGreyScale,
                          textDecoration: "none",
                        }}
                        className="pgOrderCallBtn"
                      >
                        <span style={{ paddingLeft: "10px" }}>
                          {rs.Merchant}
                        </span>
                      </button>
                    )}
                  </div>
                ))}
              </div>
            )}

            {this.state.activeTab === "cancelled" && (
              <CancelledOrders navigate={this.props.navigate} />
            )}

            {this.state.activeTab === "completed" && !hideCompletedTab && (
              <COMPLETEDORDERS
                navigate={this.props.navigate}
                hideHeader={true}
              />
            )}
          </>
        ) : (
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "350px",
                height: "100vh",
              }}
            >
              <button
                style={{
                  width: "40%",
                  height: "48px",
                  borderRadius: "6px",
                  fontFamily: F_Fammily.Regular,
                  backgroundColor: Colors.DarkGreyScale,
                  textAlign: "center",
                  alignItems: "center",
                  color: "#fff",
                  fontSize: Font.MainHeading,
                  border: "none",
                  cursor: "pointer",
                  marginTop: "",
                }}
                onClick={async () => {
                  await SET_STORE_PAGE_URL(PT_ORDERS);
                  this.props.navigate(PT_SIGNIN);
                }}
              >
                Please Sign-In
              </button>
            </div>
          </>
        )}
      </div>
    );
  }

  async canceleInvoice(GUID) {
    Alert.ConfirmationMessageBox({
      Tittle: "Cancel invoice",
      Text: "Are you sure you want to cancel this invoice?",
      CancelButtonMessage: "No",
      ConfirmButtonText: "Yes",
      ConfirmButtonFunction: async () => {
        let data = await api_CancelSalesOrderByCustomer(GUID);
        var objresponse = JSON.parse(data);

        if (objresponse.Error !== null || objresponse.Error !== "") {
          if (objresponse.GUID !== 0) {
            Alert.MessageBox({
              ConfirmButtonText: "Ok",
              Tittle: "Message",
              Text: "Invoice cancelled",
              Icon: "",
              ConfirmButtonFunction: () => {
                this.LoadPendingInvoiceFirst();
              },
            });
          } else {
            if (objresponse.Error !== "") {
              Alert.MessageBox({
                ConfirmButtonText: "Ok",
                Tittle: "Message",
                Text: objresponse.Error,
                Icon: "",
                ConfirmButtonFunction: () => {
                  this.LoadPendingInvoiceFirst();
                },
              });
            }
          }
        }
      },
    });
  }
}
